/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const defaultImage = {
    url: "",
    guid: "",
    title: "",
    description: "",
    alt: "",
    width: 0,
    height: 0,
};
const defaultLink = {
    webpage: "",
    is_external: false,
    url: "",
    title: "",
};

const defaultComponent = {
    type: null,
    guid: null,
    position: null,
};
// const old_defaultRichTextObject = {
//     "time": 0,
//     "blocks": [],
//     "version": "0"
// }
const defaultRichTextObject = {
    ops: [
        {
            insert: "\n",
        },
    ],
};
const defaultRichTextObjectPM = {
    type: "doc",
    content: [
        {
            "type": "paragraph"
        }
    ],
};
const defaultTOCRichTextObjectPM = {
    "type": "doc",
    "content": [
        {
            "type": "paragraph",
            "attrs": { "textAlign": "left", "class": null },
            "content": [
                {
                    "type": "text",
                    "marks": [ { "type": "bold" } ],
                    "text": "On this page:"
                }
            ]
        }
    ]
};

export {
    defaultLink,
    defaultComponent,
    defaultRichTextObject,
    defaultRichTextObjectPM,
    defaultTOCRichTextObjectPM,
    defaultImage
};
